// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__56gz3","comment":"styles_comment__3ICUv"};